import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ValBrowserStorageService } from '../services/val-browser-storage.service';


@Injectable()
export class ValAuthInterceptor implements HttpInterceptor {

    constructor(
        private _st: ValBrowserStorageService,
        private _r: Router,
        @Inject(LOCALE_ID) private _locale: string) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this._st.getToken();
        const currency = 'EUR'; //getLocaleCurrencyCode(this._locale);
        let authReq = req;
        if (token) {
            if (req.headers.get('upload')) {
                req.headers.delete('upload');
                authReq = req.clone({
                    headers: req.headers.set('Authorization', 'Bearer ' + this._st.getToken())
                });
            } else {
                authReq = req.clone({
                    headers: req.headers.set('Authorization', 'Bearer ' + this._st.getToken()).set('content-type', 'application/json')
                });
            }
        }
        authReq = authReq.clone({
            headers: authReq.headers.set('X-Ui-Language', this._locale)
        });
        authReq = authReq.clone({
            headers: authReq.headers.set('X-Ui-Currency', currency)
        });

        // send cloned request with header to the next handler.
        return next.handle(authReq).pipe(
            catchError((err: HttpErrorResponse) => {
                const er = { ...err };
                if (err.status === 401) {
                    this._st.logOut();
                    er.message = err ? err.error ? err.error : err.message : null;
                    this._r.navigateByUrl('/login');
                    return null;
                }
                if (err.status === 500) {
                    er.message = err.error;
                }
                if (err.status === 400) {
                    er.message = err.error;
                }
                if (err.status === 402 || err.status === 403 || err.status === 404) {
                    er.message = err.error;
                }
                return throwError(er);
            }));
    }
}
